import type { JsonDataItem } from '@myosh/odin-components';
import { useEffect, useState } from 'react';
import useFetchRecords from '../../../../hooks/use-fetch-records';
import { forceAssert } from '../../../../utils/type-guards';
import { FormLoading } from '../../../form/form-loading.component';
import Record, { RecordSaveState } from '../../../record/record.component';
import RecordPreviewPanel from './record-preview-panel';

interface LinkedRecordPreviewProps {
  recordId: string;
  onClose: () => void;
}

export default function LinkedRecordPreview({ recordId, onClose }: LinkedRecordPreviewProps) {
  const { records, isLoading } = useFetchRecords(recordId, true);
  const [record, setRecord] = useState<JsonDataItem>();

  useEffect(() => {
    if (records.length === 1) {
      setRecord(forceAssert<JsonDataItem>(records[0]));
    }
  }, [records]);

  return (
    <RecordPreviewPanel>
      {isLoading ? (
        <FormLoading />
      ) : (
        <Record
          recordId={recordId}
          formId={record?.formId as number}
          onClose={onClose}
          recordState={RecordSaveState.Update}
          title={record ? `${record['formName']} ${record['docNo']} - ${record['status']}` : ''}
          isPreview={true}
        />
      )}
    </RecordPreviewPanel>
  );
}
